import React from "react";
import { Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";

interface ButtonUXInterface {
  text: string;
  hasBorder?: boolean;
  lowercase?: boolean;
  width?: string;
  hasIcon?: boolean;
  icon?: ReactNode;
  isModal?: boolean;
  page?: number;
  isFooter?: boolean;
  isMain?: boolean;
  parallax?: any;
  fontStyle?: string;
  padding?: string;
}

const ButtonUX = ({
  text,
  isFooter,
  hasBorder,
  lowercase,
  width,
  padding,
  hasIcon,
  icon,
  isModal,
  fontStyle,
  page = 0,
  parallax,
}: ButtonUXInterface) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    const encodedText = encodeURIComponent(text).toUpperCase();

    if (text === "Home") {
      navigate("/");
    } else if (text === "Contact") {
      setTimeout(() => {
        const footer = document.getElementById("footer");
        if (footer) {
          footer.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    } else if (text === "Chi siamo") {
      // Verifica se la pagina corrente è diversa da "/about"
      if (location.pathname !== "/about") {
        navigate("/about");
      } else {
        // Scorri fino all'elemento con ID "chisiamo" se presente
        const element = document.getElementById("chisiamo");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      const element = document.getElementById(encodedText);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate(`/${text}`);
      }
    }
  };

  return (
    <Button
      sx={{
        width: width || undefined,
        backgroundColor: "transparent",
        borderRadius: "50px",
        padding: "5px 22.5px",
        color: "#0c6b8b",
        fontSize: isModal ? "10vw" : "17px",
        textAlign: isFooter ? "left" : "center",
        fontFamily: isModal || isFooter ? "ivymode" : "degular",
        fontStyle: fontStyle || "normal",
        fontWeight: 500,
        lineHeight: "14px",
        letterSpacing: isFooter ? "2px" : "1px",
        textTransform: lowercase === true || isFooter ? "none" : "uppercase",
        border: hasBorder ? "1px solid white" : "none",
      }}
      variant="text"
      onClick={handleClick}
      startIcon={icon}
    >
      {text}
    </Button>
  );
};

export default ButtonUX;
